import * as React from "react";
import type { SVGProps } from "react";
const SvgTrailerButtonMark1 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 87.406 87.375"
    {...props}
  >
    <path
      d="M354.14 959.562a43.7 43.7 0 1 1 43.706-43.7 43.7 43.7 0 0 1-43.706 43.7m0-85.205a41.51 41.51 0 1 0 41.521 41.51 41.516 41.516 0 0 0-41.521-41.51m-10.282 23.706 30.846 17.8-30.846 17.805z"
      style={{
        fill: "currentColor",
        fillRule: "evenodd",
      }}
      transform="translate(-310.438 -872.188)"
    />
  </svg>
);
export default SvgTrailerButtonMark1;
